export {getTrimmed} from "./trim"
export {maxLengthString} from "./maxLengthString"
export {hasWhitespace} from "./hasWhitespace"
